/* @flow weak */

'use strict';

const Reflux = require('reflux');
const PartActions = require('../actions/PartActions.jsx');

const _ = require('lodash');

const PartStore = Reflux.createStore({
  listenables: [PartActions],

  data: [],

  getInitialState() {
    return this.data;
  },

  onLoad(parts) {
    this.data = parts;

    this.trigger(this.data);
  },

  fetchPartsByCategory(categories) {
    return _.filter(this.data, function(part) {
      return _.intersection(part.category, categories).length > 0;
    });
  },

  fetchPartsForQuestion(questionId) {
    return _.filter(this.data, function(part) {
      return part.question_id === questionId;
    });
  },

  fetchLowestPriceForItemCode(itemCode) {
    // Grab prices for itemcodes that match.
    let prices = _.chain(this.data)
      .filter((part) => {
        // Filter out any parts without pricing for this itemCode. If part.pricing is a string, no item code match needed.
        let boolHasItemCode = (_.values(part.pricing).length === 1) ? true : typeof _.get(part, ['pricing', itemCode]) !== 'undefined';
        // Also filter out non-metal prices. Starting at pricing should be the lowest metal price.
        let boolIsMetalPart = typeof _.get(part, ['metadata', 'MetalCode']) !== 'undefined';

        return boolHasItemCode && boolIsMetalPart;
      })
      .map((part) => {
        return part.pricing[itemCode];
      })
      .value();

    // Sort the prices and return the first entry
    return prices.sort(function (a, b) {
      return parseFloat(a.retail_price).toFixed(2) - parseFloat(b.retail_price).toFixed(2);
    })[0];
  },

  getPartByQuestionAndPartId(question_id, part_id) {
    return _.filter(this.data, (part) => {
      return part.id === part_id && part.question_id === question_id;
    })[0];
  }
});

module.exports = PartStore;


// WEBPACK FOOTER //
// ./src/base/scripts/stores/PartStore.jsx